import { createAnonymousMittBffClient } from '@/app/bffClient';
import { downloadFile } from 'bff-api/mitt-malarenergi';

export type DownloadProgress = {
  loaded: number;
  total?: number;
};

const createProgressFetch = (
  onDownloadProgress: (progress: DownloadProgress) => void,
): typeof fetch => {
  return async (input, init) => {
    const response = await fetch(input, init);
    const reader = response.body?.getReader();

    if (!reader) {
      return response;
    }

    const totalHeader = response.headers.get('content-length');
    const total = totalHeader ? Number(totalHeader) : undefined;
    let loaded = 0;

    const stream = new ReadableStream<Uint8Array>({
      async pull(controller) {
        const { done, value } = await reader.read();
        if (done) {
          controller.close();
          return;
        }

        loaded += value.byteLength;
        onDownloadProgress({ loaded, total });
        controller.enqueue(value);
      },
      cancel(reason) {
        return reader.cancel(reason);
      },
    });

    return new Response(stream, {
      headers: response.headers,
      status: response.status,
      statusText: response.statusText,
    });
  };
};

export const fetchReportForAnonymousUser = async (
  token: string,
  onDownloadProgress: (progress: DownloadProgress) => void,
) => {
  const client = await createAnonymousMittBffClient(
    createProgressFetch(onDownloadProgress),
  );
  return downloadFile({
    client,
    body: { token },
    parseAs: 'blob',
    throwOnError: true,
  });
};
